import { useState, useCallback, useEffect } from "react";
import _ from "lodash";
import fp from "lodash/fp";
import { useWatch } from "react-hook-form";

function difference(object, base) {
	return _.transform(object, function (result, value, key) {
		if (!_.isEqual(value, base[key])) {
			(result as any)[key] =
				_.isObject(value) && _.isObject(base[key])
					? difference(value, base[key])
					: value;
		}
	});
}

const useDirtyWatcher = ({ initialValues, control }) => {
	const values = useWatch({ control });
	const [dirty, setDirty] = useState<boolean>(false);

	const updateDirty = useCallback(
		values => {
			const newDirty = _.flow(
				fp.merge(initialValues),
				mergedValues => difference(mergedValues, initialValues),
				valuesDiff => {
					return !_.isEmpty(valuesDiff);
				},
			)(values);

			setDirty(newDirty);
		},
		[initialValues],
	);

	useEffect(() => {
		updateDirty(values);
	});

	return dirty;
};

export default useDirtyWatcher;
